import defaultAvatar from "@/assets/default_avatar.svg";
import fingerprint from "@/assets/fingerprint.svg";
import folderBlue from "@/assets/folder-blue.svg";
import locationPinBlue from "@/assets/location-pin-blue.svg";
import Button from "@/common/elements/Button";
import Dropdown, { DROPDOWN_VARIANT } from "@/common/elements/Dropdown";
import DropdownV2 from "@/common/elements/DropdownV2";
import {
  CameraFilled,
  DeleteOutlined,
  EditOutlined,
  EyeFilled,
  FileAddOutlined,
  FlagOutlined,
  LeftOutlined,
  MoreOutlined,
  RightOutlined,
  SignatureOutlined,
} from "@ant-design/icons";
import { useEffect, useRef, useState } from "react";
import { Row } from "react-bootstrap";
import InmateFlag, { INMATE_FLAG_TYPE } from "../InmateFlag";
import InmateProgress, {
  COLOR_MODE,
  INMATE_PROGRESS_MODE,
} from "../InmateProgress";
import ManageFlagsModal from "./ManageFlagsModal";
import {
  BookingFlagsContainer,
  BookingsSectionTitle,
  InmateDetails,
  InmateHeaderContainer,
  InmateInformation,
  InmateName,
  InmatePreviewContainer,
} from "./styles";
import API_ENDPOINTS, { PHOTOS_BASE_URL, WEB_SOCKET_URL } from "@/util/api";
import JacketDetailsModal from "../BookingsDetails/JacketDetails/JacketDetailsModal";
import { useDispatch, useSelector } from "react-redux";
import Modal from "@/common/elements/Modal";
import FileUploader from "../FileUploader";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import api from "@/services/axios_custom";
import { setBookings, setDeleteAPis } from "@/slices/bookingsSlice";
import { Flex, Image, message } from "antd";
import {
  base64ToBlob,
  isNonEmptyVariable,
  getRefListItemsbyName,
  getRefListNameByID,
  findAgefromDOB,
} from "@/util/common_function";
import { v4 as uuidV4 } from "uuid";
import useDialog from "@/hooks/useDialog.jsx";
import { Camera } from "react-camera-pro";
import notificationService from "@/util/notificationService";
import { getDisplayInvolvements } from "@/components/BookingsDetails/JacketDetails/flagUtils";

const InmateHeader = ({
  onSuccess,
  defaultInfo = true,
  customInfo = null,
  inmateMainTitle = null,
  parentKey = "bookings",
  fromFolderDetails = false,
  showPreviewActionsAndAvatar = true,
  // When true, the mugshot is view-only: the prev/next photo paging still
  // works, but the New/Modify/Delete camera dropdown that manages bio
  // photos is hidden. Used by modules (e.g. Transport) that should show
  // the inmate's existing mugshot without letting it be managed from there.
  readOnlyAvatar = false,
}) => {
  const dispatch = useDispatch();
  const { bookings, bookingsFieldsEnabled, jacketFlags } = useSelector(
    (state) => state.bookings,
  );
  const { showDialog } = useDialog();
  const camera = useRef(null);
  let [controllingCharge, setControllingCharge] = useState(null);
  let [classLevel, setClassLevel] = useState(null);
  const [classColour, setClassColour] = useState("");
  let [inmateType, setInmateType] = useState(null);

  function findControllingCharge() {
    if (bookings?.charges?.length) {
      let allCharges = [...bookings.charges];
      for (let i = 0; i < allCharges.length; i++) {
        if (allCharges[i].controllingCharge) {
          return allCharges[i].chargeDescriptionID;
        }
      }
    }
    return null;
  }

  function findClassLevel() {
    if (bookings?.inmateClassificationQuestionnaires?.length) {
      let classifications = [...bookings.inmateClassificationQuestionnaires];
      let len = classifications.length;
      let classificationId = classifications[len - 1]?.classificationID;
      return classificationId;
    }
    return null;
  }

  function findInmateType() {
    if (
      bookings?.bio?.[0]?.dob &&
      !bookings?.arrestReports?.[0]?.inmateTypeId
    ) {
      let age = findAgefromDOB(bookings?.bio?.[0]?.dob);
      let iTyp = age < 18 ? 154540005 : 154540001;
      return iTyp;
    } else if (bookings?.arrestReports?.length) {
      let iTyp = bookings.arrestReports[0]?.inmateTypeId;
      return iTyp;
    }
    return null;
  }

  const setDefaultClassColour = (level) => {
    const colour =
      level === "Minimum"
        ? "green"
        : level === "Medium"
          ? "blue"
          : level === "Maximum"
            ? "red"
            : "";
    setClassColour(colour);
  };

  function setClassificationColour(level) {
    const url = API_ENDPOINTS.config.refList.getRefListItemWithAttribs;
    api
      .get(url)
      .then((data) => {
        const refAttributes = data?.data?.refListItemCustomResponses?.find(
          (reflistItem) => reflistItem?.defaultString === level,
        );

        if (!refAttributes) {
          setDefaultClassColour(level);
          return;
        }

        const classBannerColour = refAttributes?.refListItemAttribs?.find(
          (colourData) => colourData?.attribName === "BannerColor",
        );

        if (!classBannerColour) {
          setDefaultClassColour(level);
          return;
        }

        setClassColour(classBannerColour?.attribValue?.toLowerCase());
      })
      .catch((err) => {
        setDefaultClassColour(level);
      });
  }

  useEffect(() => {
    let cCharge = null;
    let classL = null;
    let iType = null;
    let cChargeVal = findControllingCharge();
    let classLVal = findClassLevel();
    let iTypeVal = findInmateType();
    if (cChargeVal) {
      cCharge = getRefListNameByID("Charges", cChargeVal);
    }
    if (classLVal) classL = getRefListNameByID("Classifications", classLVal);
    if (iTypeVal) iType = getRefListNameByID("Inmate_Type", iTypeVal);
    if (cCharge) {
      setControllingCharge(cCharge);
    } else {
      setControllingCharge(null);
    }
    if (classL) {
      // let strArr = classL.split(" ");
      // classL = strArr[1];
      setClassLevel(classL);
      setClassificationColour(classL);
    } else {
      setClassColour("");
      setClassLevel(null);
    }
    if (iType) {
      setInmateType(iType);
    } else {
      setInmateType(null);
    }
  }, [bookings]);

  const [jacketDetailsModal, setJacketDetailsModal] = useState(false);
  const handleJacketDetailsModal = () => {
    setJacketDetailsModal(!jacketDetailsModal);
  };
  const [user, setUser] = useState(null);
  const [manageFlagsModalShown, setManageFlagsModalShown] = useState(false);
  const [bioPhotoModalShow, setBioPhotoModalShow] = useState(false);
  const [bioPhotoCaptureModalShow, setBioPhotoCaptureModalShow] =
    useState(false);
  const [selectedBioPhotos, setSelectedBioPhotos] = useState(null);
  const [option, setOption] = useState(null);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [bioPhotos, setBioPhotos] = useState([]);

  const [showBioPhotoIndex, setShowBioPhotoIndex] = useState(-1);
  const [bioPhotoUrl, setBioPhotoUrl] = useState("");
  const [isBioPhotoEdit, setIsBioPhotoEdit] = useState(false);
  const [bioDetails, setBioDetails] = useState(null);
  const [isAPICallforBioPhotoUploading, setisAPICallforBioPhotoUploading] =
    useState(false);
  const [numberOfCameras, setNumberOfCameras] = useState(0);
  const [isCapturePhoto, setisCapturePhoto] = useState(false);
  const [captureImage, setCaptureImage] = useState(null);
  const [devices, setDevices] = useState([]);
  const [activeDeviceId, setActiveDeviceId] = useState(null);
  const [assignedLocation, setAssignedLocation] = useState(null);
  const [currentLocation, setCurrentLocation] = useState(null);
  const refList = useSelector((state) => state?.refListReducer?.refLists);

  // Get login user details from local storage and store in it local state => user
  useEffect(() => {
    const userLocal = JSON.parse(localStorage.getItem("userDetails"));
    if (isNonEmptyVariable(userLocal)) {
      setUser(userLocal);
    }
  }, []);

  useEffect(() => {
    setOption(() => selectedBioPhotos?.photos?.[0]?.imageType ?? "Mug-Front");
  }, [selectedBioPhotos]);

  // Store older bio details and photos into local state
  useEffect(() => {
    if (bookings !== null) {
      setBioDetails(bookings?.bio?.[0]);
      const bioPhoto = bookings?.bio?.[0]?.bioPhotos?.map((bp) => {
        return {
          ...bp,
          uuid: uuidV4(),
        };
      });
      setBioPhotos(bioPhoto);
      setShowBioPhotoIndex(() => 0);
      selectedBioPhotos?.photos?.[0]?.imageType;
    } else {
      setBioPhotos(() => []);
      setShowBioPhotoIndex(() => -1);
    }
  }, [bookings]);

  // Calling getBioPhoto after depencies update of bioPhotos and bioPhotosPagination change
  useEffect(() => {
    const inmateTracking = bookings?.inmateTracking;

    if (Array.isArray(inmateTracking) && inmateTracking.length > 0) {
      // Get all Complete records that have a relevant inmateLocation
      const relevantStatuses = ["Perm Housing Change", "In Jail", "RELEASED"];

      const completedRecords = inmateTracking.filter(
        (t) =>
          isNonEmptyVariable(t) &&
          t?.movementStatus === "Complete" &&
          relevantStatuses.includes(t?.inmateLocation),
      );

      // Pick the one with the highest inmateTrackingID (most recent)
      const latestRecord =
        completedRecords.length > 0
          ? completedRecords.reduce((max, t) =>
              t.inmateTrackingID > max.inmateTrackingID ? t : max,
            )
          : null;

      if (isNonEmptyVariable(latestRecord)) {
        if (
          latestRecord.inmateLocation === "Perm Housing Change" ||
          latestRecord.inmateLocation === "RELEASED"
        ) {
          // Priority 1 — no housing assignment
          setAssignedLocation("No housing assignment");
        } else if (latestRecord.inmateLocation === "In Jail") {
          // Priority 2 — resolve cell/holding location
          const { inJailType, block, cell, bed, holdingCell } = latestRecord;

          if (inJailType === "Cell") {
            const finalLoc = `${inJailType} - ${block || ""}  ${cell || ""}  ${bed || ""}`;
            setAssignedLocation(finalLoc);
          } else if (inJailType === "Holding") {
            const finalLoc = `${inJailType} - ${holdingCell || ""}`;
            setAssignedLocation(finalLoc);
          } else {
            setAssignedLocation(null);
          }
        }
      } else {
        setAssignedLocation(null);
      }
    } else {
      setAssignedLocation(null);
    }

    if (bookings?.arrestReports?.[0]?.currentLocation) {
      setCurrentLocation(bookings.arrestReports[0].currentLocation);
    } else {
      setCurrentLocation(null);
    }
  }, [bookings?.inmateTracking, bookings?.arrestReports]); // ← added inmateTracking dep

  useEffect(() => {
    if (showBioPhotoIndex === -1 && bioPhotos?.length) {
      setShowBioPhotoIndex(() => 0);
    }
    getBioPhoto();
  }, [bioPhotos, showBioPhotoIndex]);

  const checkCameraPermission = async () => {
    try {
      const permissionStatus = await navigator.permissions.query({
        name: "camera",
      });

      if (permissionStatus.state === "granted") {
      } else if (permissionStatus.state === "denied") {
      } else {
        alert(
          "Camera permission is in prompt state. User has not decided yet.",
        );
      }

      // Listen for permission changes
      permissionStatus.onchange = () => {};

      return permissionStatus.state;
    } catch (error) {}
  };

  const stopCamera = () => {
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        stream.getTracks().forEach((track) => {
          track.stop(); // Stop each track
          stream.removeTrack(track); // Remove track from the stream
        });
      })
      .catch();
  };

  const handleOnManageFlagsClick = () => {
    setManageFlagsModalShown(true);
  };

  const handleModal = (v) => {
    setIsBioPhotoEdit(false);
    if (v?.key === "new") {
      setSelectedBioPhotos(null);
      setOption("Mug-Front");
    } else if (v?.key === "delete") {
      if (bioPhotos?.length) {
        setSelectedBioPhotos(bioPhotos?.[showBioPhotoIndex]);
      }
      deleteBioPhotoActionTrigger();
      return;
    } else {
      if (bioPhotos?.length) {
        setSelectedBioPhotos(bioPhotos?.[showBioPhotoIndex]);
      }
      setOption(bioPhotos?.[showBioPhotoIndex]?.photos?.[0]?.imageType);
      setIsBioPhotoEdit(true);
    }

    if (!bioPhotoModalShow) {
      setisCapturePhoto(() => false);
      setCaptureImage(() => null);
      setNumberOfCameras(() => 0);
      setBioPhotoCaptureModalShow(() => false);
    }

    setBioPhotoModalShow(!bioPhotoModalShow);
  };

  const onApplyFilter = (data) => {
    const res = base64ToBlob(data);
    handleFileUpload(res);
  };

  const takePhoto = async () => {
    const cp = await checkCameraPermission();

    if (cp === "denied") {
      return;
    }

    if (cp === "granted") {
      setisCapturePhoto(() => true);
      setCaptureImage(() => camera.current.takePhoto());
      const res = base64ToBlob(camera.current.takePhoto());
      handleFileUpload(res);
      handleCaptureModal(false);
    }
  };

  const handleCaptureModal = async (show) => {
    if (!show) {
      stopCamera();
    }

    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then(async (stream) => {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoDevices = devices?.filter((i) => i.kind == "videoinput");
        setDevices(videoDevices);
        setBioPhotoCaptureModalShow(() => show);
      })
      .catch((error) => {
        alert("Permission denied: " + error.message);
      });
  };

  const handleOptionChange = (value) => {
    setOption(value);
  };

  // Bio Photos upload functionalities methods start
  const handleFileUpload = (file) => {
    if (file) {
      setUploadedImage(file);
    } else {
    }
  };

  let config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  const getFinalPath = (path) => {
    if (path?.includes("\\")) {
      const splitPath = path?.split("/");
      if (splitPath?.length === 4) {
        splitPath.shift();
        splitPath.shift();
      }

      return splitPath?.join("\\");
    }

    return path;
  };

  const onSaveClick = () => {
    let bioPhotosData = bioPhotos || [];
    if (!option) {
      notificationService.error("Please select an Image Type.");
      return;
    }

    if (!isBioPhotoEdit && !uploadedImage) {
      notificationService.error("Please upload an image.");
      return;
    }

    if (isBioPhotoEdit) {
      bioPhotosData = bioPhotosData?.map((bp) => {
        if (bp?.uuid === selectedBioPhotos?.uuid) {
          return {
            ...bp,
            photos: [
              {
                ...bp?.photos?.[0],
                imageType: option,
              },
            ],
          };
        }

        return bp;
      });
      setBioPhotos(bioPhotosData);
      dispatch(
        setBookings({
          bio: [
            {
              ...bookings?.bio?.[0],
              bioPhotos: bioPhotosData,
            },
          ],
        }),
      );
      setBioPhotoModalShow(false);
      return;
    }

    const formData = new FormData();
    formData.append("imageType", option);

    formData.append("file", uploadedImage, "photo.jpg");

    setisAPICallforBioPhotoUploading(() => true);
    api
      .post(API_ENDPOINTS.imageUpload, formData, config)
      .then((response) => {
        const { body } = response.data;
        const bioPhoto = {
          photos: [body],
        };
        bioPhotosData.push(bioPhoto);
        dispatch(
          setBookings({
            bio: [
              {
                ...bookings?.bio?.[0],
                bioPhotos: bioPhotosData,
              },
            ],
          }),
        );
      })
      .catch((error) => {})
      .finally(() => {
        setBioPhotoModalShow(false);
        setisAPICallforBioPhotoUploading(() => false);
      });
  };

  const prevBioPhotos = () => {
    if (showBioPhotoIndex <= 0) {
      setShowBioPhotoIndex(0);
    } else {
      setShowBioPhotoIndex((prev) => prev - 1);
    }
  };

  const nextBioPhotos = () => {
    if (showBioPhotoIndex >= bioPhotos?.length) {
      setShowBioPhotoIndex(bioPhotos?.length);
    } else {
      setShowBioPhotoIndex((prev) => prev + 1);
    }
  };

  const getBioPhoto = () => {
    if (bioPhotos?.length === 0 || showBioPhotoIndex === -1) {
      setBioPhotoUrl(() => defaultAvatar);
      return;
    }
    setBioPhotoUrl(
      () =>
        PHOTOS_BASE_URL +
        getFinalPath(bioPhotos?.[showBioPhotoIndex]?.photos?.[0]?.fullSizePath),
    );
    return;
  };

  const deleteBioPhotoActionTrigger = () => {
    showDialog("confirm", {
      title: "Are you sure you want to delete?",
      message: "Are you sure you want to delete?",
      onConfirm: () => {
        deleteBioPhoto();
      },
    });
  };

  const deleteBioPhoto = () => {
    let bioPhotosData = bioPhotos;
    const deleteData = bioPhotos?.[showBioPhotoIndex];
    bioPhotosData = bioPhotosData?.filter((bp) => {
      return bp?.uuid !== deleteData?.uuid;
    });
    setBioPhotos(bioPhotosData);

    const url = API_ENDPOINTS.bioPhotos + "/id/" + deleteData?.bioPhotoID;
    dispatch(setDeleteAPis(url));

    dispatch(
      setBookings({
        bio: [
          {
            ...bookings?.bio?.[0],
            bioPhotos: bioPhotosData,
          },
        ],
      }),
    );
    setSelectedBioPhotos(null);
    setShowBioPhotoIndex((prev) => prev - 1);
  };

  const handleImageError = (e) => {
    setBioPhotoUrl(() => defaultAvatar);
  };

  // Bio Photos upload functionalities methods end

  const getRelevantInvolvements = (cdInvolvements, flagTypeConstant) => {
    if (!cdInvolvements || !cdInvolvements.length) return [];

    const filterFT = getRefListItemsbyName("FlagTypes")?.filter((f) => {
      return f?.constantName === flagTypeConstant;
    });
    if (!filterFT || !filterFT.length) return [];

    const refId = filterFT[0].refListItemGlobalId;
    const filtered = cdInvolvements.filter((inv) => {
      return (
        inv.flagTypeID === refId ||
        inv.dangerTypeId === refId ||
        inv.gangTypeId === refId ||
        inv.medicalTypeId === refId ||
        inv.noteTypeId === refId ||
        inv.civicTypeId === refId
      );
    });
    return filtered;
  };

  const renderFlag = (flagType) => {
    // Includes each Classification questionnaire's own nested cdInvolvement
    // (see setJacketFlagsForQuestionnaire in ClassificationQuestionnairesList),
    // not just the booking-root cdInvolvements array, so e.g. the Gang flag
    // lights up as soon as "Known gang affiliation?" is answered Yes.
    // Saved flags are limited to what flags/jacket/{jacketId} returned - see
    // getDisplayInvolvements.
    const cdInvolvements = getDisplayInvolvements(bookings, jacketFlags);
    const relevantInvolvements = getRelevantInvolvements(
      cdInvolvements,
      flagType,
    );
    const flagEnabled = relevantInvolvements.length > 0;
    return (
      <InmateFlag
        key={flagType}
        type={flagType}
        flagEnabled={flagEnabled}
        cdInvolvements={relevantInvolvements}
        isEdit={true}
      />
    );
  };

  const irisAppOpen = () => {
    // window.location.href = "myapp://open-scanner";
  };

  return (
    <>
      <div>
        <InmateHeaderContainer>
          <div className="left">
            <img
              alt="Folder Icon Blue"
              src={folderBlue}
              // onClick={handleJacketDetailsModal}
              onClick={
                (bookings?.bookingNumber ||
                  bookings?.staffId ||
                  bookings?.jacketId) &&
                !!!fromFolderDetails
                  ? handleJacketDetailsModal
                  : undefined
              }
              // style={{ cursor: "pointer" }}
              style={{
                cursor:
                  bookings?.bookingNumber || bookings?.jacketId
                    ? "pointer"
                    : "default",
                opacity:
                  bookings?.bookingNumber || bookings?.jacketId ? 1 : 0.5,
              }}
            />{" "}
            &nbsp;
            <InmateName>
              {isNonEmptyVariable(bookings?.bio?.[0]?.fName) ||
              isNonEmptyVariable(bookings?.bio?.[0]?.lName)
                ? `${bookings?.bio?.[0]?.fName || ""} ${
                    isNonEmptyVariable(bookings?.bio?.[0]?.mName)
                      ? bookings?.bio?.[0]?.mName
                      : ""
                  } ${bookings?.bio?.[0]?.lName || ""}${
                    isNonEmptyVariable(bookings?.bio?.[0]?.suffix)
                      ? `, ${bookings?.bio?.[0]?.suffix}`
                      : ""
                  }${
                    isNonEmptyVariable(bookings?.jacketId)
                      ? ` (${bookings?.jacketId})`
                      : ""
                  }`
                    .replace(/\s+/g, " ")
                    .trim()
                : inmateMainTitle || "New Warrant"}
            </InmateName>
            {/* <InmateName>
              {isNonEmptyVariable(bookings?.bio?.[0]?.lName) &&
              isNonEmptyVariable(bookings?.bio?.[0]?.fName)
                ? bookings?.bio?.[0].lName +
                  " " +
                  bookings?.bio?.[0].fName +
                  " " +
                  (isNonEmptyVariable(bookings?.bio?.[0].mName)
                    ? bookings?.bio?.[0].mName + " "
                    : " ")
                : inmateMainTitle
                  ? inmateMainTitle
                  : "New Folder"}
              {}
              {isNonEmptyVariable(bookings?.jacketId)
                ? " - " + bookings?.jacketId
                : " "}
              {isNonEmptyVariable(bookings?.visitorLogId)
                ? " - " + bookings?.visitorLogId
                : " "}
              {isNonEmptyVariable(bookings?.rankHr?.[0]?.rank)
                ? "; " + bookings?.rankHr?.[0]?.rank
                : " "}
              {isNonEmptyVariable(bookings?.badge)
                ? "; " + bookings?.badge
                : " "}{" "}
              {isNonEmptyVariable(bookings?.staffId)
                ? "- " + bookings?.staffId + " "
                : " "}
            </InmateName> */}
          </div>
          <div className="right">
            <BookingFlagsContainer>
              {renderFlag(INMATE_FLAG_TYPE.WARRANT)}
              {renderFlag(INMATE_FLAG_TYPE.CIVIC)}
              {renderFlag(INMATE_FLAG_TYPE.DANGER)}
              {renderFlag(INMATE_FLAG_TYPE.INJAIL)}
              {renderFlag(INMATE_FLAG_TYPE.GANG)}
              {renderFlag(INMATE_FLAG_TYPE.MEDICAL)}
              {renderFlag(INMATE_FLAG_TYPE.NOTES)}
              <DropdownV2
                pl="20px"
                // menuItems={[
                //   {
                //     key: 1,
                //     label: <>Manage Flags</>,
                //     icon: <FlagOutlined />,
                //     onClick: handleOnManageFlagsClick,
                //   },
                // ]}
                content={
                  <>
                    <MoreOutlined
                      style={{ fontSize: "16px", fontWeight: "bold" }}
                    />
                  </>
                }
              />
            </BookingFlagsContainer>
          </div>
        </InmateHeaderContainer>
        <InmatePreviewContainer>
          {showPreviewActionsAndAvatar && (
            <>
              <div className="preview-actions">
                {/* <div className="prf-actions">
                  <DropdownV2
                    placement="rightTop"
                    menuItems={[
                      {
                        key: "signature",
                        icon: <SignatureOutlined />,
                        label: "Signature",
                      },
                      // {
                      //   key: "finger-print",
                      //   icon: (
                      //     <img
                      //       src={fingerprint}
                      //       alt="Finger Print Icon"
                      //       width="16px"
                      //     />
                      //   ),
                      //   label: "Finger Print",
                      // },
                    ]}
                    content={
                      <Button
                        icon={<MoreOutlined style={{ fontSize: "20px" }} />}
                      />
                    }
                  />
                </div>
                <Button
                  color="primary"
                  type="primary"
                  variant="solid"
                  icon={<EyeFilled />}
                  onClick={irisAppOpen}
                  disabled={!bookingsFieldsEnabled}
                ></Button> */}
                {!readOnlyAvatar && (
                  <div className="prf-actions">
                    <DropdownV2
                      placement="rightTop"
                      menuItems={[
                        { key: "new", icon: <FileAddOutlined />, label: "New" },
                        {
                          key: "edit",
                          icon: <EditOutlined />,
                          label: "Modify",
                          disabled: !bioPhotos?.length,
                        },
                        {
                          key: "delete",
                          icon: <DeleteOutlined />,
                          label: "Delete",
                          disabled: !bioPhotos?.length,
                        },
                      ]}
                      onSelect={handleModal}
                      content={
                        <Button
                          disabled={!bookingsFieldsEnabled}
                          icon={<CameraFilled style={{ fontSize: "20px" }} />}
                        />
                      }
                      disabled={!bookingsFieldsEnabled}
                    />
                  </div>
                )}
                <Flex>
                  <Button
                    color="primary"
                    className="bio-photos-btn"
                    size="small"
                    type="primary"
                    variant="solid"
                    onClick={prevBioPhotos}
                    icon={<LeftOutlined />}
                    disabled={
                      showBioPhotoIndex === 0 ||
                      showBioPhotoIndex === -1 ||
                      bioPhotos?.length <= 1
                    }
                  ></Button>
                  <Button
                    color="primary"
                    className="bio-photos-btn"
                    size="small"
                    type="primary"
                    variant="solid"
                    onClick={nextBioPhotos}
                    icon={<RightOutlined />}
                    disabled={
                      showBioPhotoIndex === bioPhotos?.length - 1 ||
                      showBioPhotoIndex === -1 ||
                      bioPhotos?.length <= 1
                    }
                  ></Button>
                </Flex>

                {bioPhotos?.length ? (
                  <div className="pages">
                    {showBioPhotoIndex + 1}/{bioPhotos?.length}
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="avatar-container">
                <Image
                  alt="Default Inmate Avatar"
                  className="avatar"
                  src={bioPhotoUrl}
                  width={200}
                  height={200}
                  onError={handleImageError}
                  fallback={defaultAvatar}
                />
              </div>
            </>
          )}
          {defaultInfo && (
            <InmateDetails fluid>
              <Row style={{ marginTop: "10px" }}>
                <InmateInformation xs={6}>
                  <div className="key">Booking No/Officer</div>
                  <div className="value justify-content-between">
                    {isNonEmptyVariable(bookings?.bookingNumber) ? (
                      <span className="officer">{bookings?.bookingNumber}</span>
                    ) : (
                      <> - </>
                    )}
                    <span className="officer">
                      {isNonEmptyVariable(bookings?.creatorStaffId)
                        ? getRefListNameByID(
                            "",
                            bookings?.creatorStaffId,
                            true,
                            true,
                          )
                        : ""}
                    </span>
                  </div>
                </InmateInformation>
                <InmateInformation>
                  <div className="key">Class</div>
                  <div
                    className={`value justify-content-between`}
                    style={{ background: classColour }}
                  >
                    {isNonEmptyVariable(classLevel) ? (
                      <span>{classLevel}</span>
                    ) : (
                      <> - </>
                    )}
                  </div>

                  {/* <Dropdown
                  className="value green"
                  id={`dropdown-variants-test`}
                  title={"test"}
                  variant={DROPDOWN_VARIANT.TEXT}
                >
                  <Dropdown.Item>test</Dropdown.Item>
                  <Dropdown.Item>test</Dropdown.Item>
                </Dropdown> */}
                </InmateInformation>
                <InmateInformation>
                  <div className="key">Type</div>
                  <div className="value justify-content-between ">
                    {isNonEmptyVariable(inmateType) ? (
                      <span>{inmateType}</span>
                    ) : (
                      <> - </>
                    )}
                  </div>
                </InmateInformation>
              </Row>
              <Row style={{ marginTop: "10px" }}>
                <InmateInformation>
                  <div className="key">Charges</div>
                  <div className="value">
                    {isNonEmptyVariable(controllingCharge) ? (
                      <span className="officer">{controllingCharge}</span>
                    ) : (
                      <> - </>
                    )}
                  </div>
                </InmateInformation>
              </Row>
              <Row style={{ marginTop: "10px" }}>
                <InmateInformation>
                  {/* <div className="key">Status</div>
                  <div className="value">
                    <InmateProgress
                      progress={INMATE_PROGRESS_MODE.BOOKING_IN_PROGRESS}
                      colorMode={COLOR_MODE.GREEN_ORANGE_ON_BLUE}
                    />
                  </div> */}
                  <div className="key">
                    <img alt="Location Icon" src={locationPinBlue} /> Assigned
                    Location
                  </div>
                  <div className="value">{assignedLocation || "-"}</div>
                </InmateInformation>
                <InmateInformation>
                  <div className="key">
                    <img alt="Location Icon" src={locationPinBlue} /> Location
                  </div>
                  <div className="value orange">{currentLocation || "-"}</div>
                </InmateInformation>
              </Row>

              {/* <Row>
              <InmateInformation>
                <div className="key">
                  <img alt="Location Icon" src={locationPinBlue} /> Location
                </div>
                <Dropdown
                  className="value orange"
                  id={`dropdown-variants-test`}
                  title={'Dakota county jail'}
                  variant={DROPDOWN_VARIANT.TEXT}
                >
                  <Dropdown.Item>test</Dropdown.Item>
                  <Dropdown.Item>test</Dropdown.Item>
                </Dropdown>
              </InmateInformation>
              <InmateInformation>
                <div className="key">
                  <img alt="Housing Icon" src={housingBlue} />
                  Housing
                </div>
                <Dropdown
                  className="value"
                  id={`dropdown-variants-test`}
                  title={'Dakota county jail'}
                  variant={DROPDOWN_VARIANT.TEXT}
                >
                  <Dropdown.Item>test</Dropdown.Item>
                  <Dropdown.Item>test</Dropdown.Item>
                </Dropdown>
              </InmateInformation>
            </Row>
            <Row>
              <InmateInformation className="inmate-movement-information">
                <div className="key">
                  <img alt="Inmate Movement Icon" src={inmateMovementBlue} />
                  10:15 AM - Arrived at Dakota County Jail for Booking
                </div>
                <Dropdown
                  className="value"
                  id={`dropdown-variants-test`}
                  title={'Move'}
                  variant={DROPDOWN_VARIANT.TEXT}
                >
                  <Dropdown.Item>test</Dropdown.Item>
                  <Dropdown.Item>test</Dropdown.Item>
                </Dropdown>
                <Dropdown
                  className="value"
                  id={`dropdown-variants-test`}
                  title={'Update Location'}
                  variant={DROPDOWN_VARIANT.TEXT}
                >
                  <Dropdown.Item>test</Dropdown.Item>
                  <Dropdown.Item>test</Dropdown.Item>
                </Dropdown>
                <Dropdown
                  className="value"
                  id={`dropdown-variants-test`}
                  title={'Move'}
                  variant={DROPDOWN_VARIANT.TEXT}
                >
                  <Dropdown.Item>test</Dropdown.Item>
                  <Dropdown.Item>test</Dropdown.Item>
                </Dropdown>
              </InmateInformation>
            </Row> */}
            </InmateDetails>
          )}
          {!defaultInfo && customInfo && <>{customInfo}</>}
        </InmatePreviewContainer>
      </div>
      <ManageFlagsModal
        show={manageFlagsModalShown}
        onHide={() => setManageFlagsModalShown(false)}
      />
      <JacketDetailsModal
        show={jacketDetailsModal}
        onHide={handleJacketDetailsModal}
        parentKey={parentKey}
      />

      {bioPhotoModalShow && (
        <Modal
          header={isBioPhotoEdit ? "Modify Photo" : "Add Photo"}
          show={bioPhotoModalShow}
          onHide={handleModal}
          width={"80%"}
          designPattern="ant"
          handleSubmit={onSaveClick}
          loading={isAPICallforBioPhotoUploading}
          handleCancel={handleModal}
          // footerActions={[
          //   {
          //     key: "save",
          //     text: isBioPhotoEdit ? "Update" : "Save",
          //     onClick: onSaveClick,
          //     isLoading: isAPICallforBioPhotoUploading,
          //   },
          // ]}
          // footerCloseAction
          // footerCloseActionText="Close"
        >
          <StyledGridRow gutter={16}>
            <StyledGridCol span={24}>
              <BookingsSectionTitle style={{ marginTop: "0" }}>
                <span>Photo Information</span>
              </BookingsSectionTitle>
            </StyledGridCol>
          </StyledGridRow>

          <StyledGridRow gutter={16} justify="center">
            <StyledGridCol lg={10} marginBottom="15px">
              <FormItem label="Image Type" required>
                <Select
                  placeholder="Image Type"
                  showSearch={false}
                  value={option}
                  // defaultValue={selectedBioPhotos?.photos?.[0]?.imageType}
                  options={[
                    {
                      value: "Injury",
                      label: "Injury",
                    },
                    {
                      value: "Mug-Front",
                      label: "Mug-Front",
                    },
                    {
                      value: "Mug-Other",
                      label: "Mug-Other",
                    },
                    {
                      value: "Mug-Release",
                      label: "Mug-Release",
                    },
                    {
                      value: "Mug-Side",
                      label: "Mug-Side",
                    },
                    {
                      value: "Other",
                      label: "Other",
                    },
                  ]}
                  // options={getOptionsFromRefList(
                  //   "Image_Type",
                  //   false,
                  //   false,
                  //   true
                  // )}
                  onChange={handleOptionChange}
                />
              </FormItem>
            </StyledGridCol>

            <StyledGridCol>
              <Button
                style={{ marginTop: "29px" }}
                type="default"
                color="default"
                disabled={isBioPhotoEdit}
                onClick={() => handleCaptureModal(true)}
              >
                Capture
              </Button>
            </StyledGridCol>
          </StyledGridRow>

          <StyledGridRow justify="center">
            <StyledGridCol xs={24} lg={18}>
              <FileUploader
                isCaptureAllowed={true}
                onCapture={() => handleCaptureModal(true)}
                layout="split"
                browseFileType="image"
                acceptImageFormats="image/png,image/jpeg,image/jpg"
                canvasMaxHeight="100%"
                allowMultiple={false}
                onUpload={handleFileUpload}
                imageUrlFromParent={
                  !isCapturePhoto &&
                  isNonEmptyVariable(
                    selectedBioPhotos?.photos?.[0]?.fullSizePath,
                  )
                    ? PHOTOS_BASE_URL +
                      getFinalPath(selectedBioPhotos?.photos?.[0]?.fullSizePath)
                    : captureImage
                }
                isEdit={isBioPhotoEdit}
                onApplyFilter={onApplyFilter}
              />
            </StyledGridCol>
          </StyledGridRow>
        </Modal>
      )}

      {bioPhotoCaptureModalShow && (
        <Modal
          header="Capture photo"
          show={bioPhotoCaptureModalShow}
          onHide={() => handleCaptureModal(false)}
          size="xl"
          designPattern="ant"
          footerActionsNeed={false}
        >
          <StyledGridRow>
            <StyledGridCol span={24}>
              <BookingsSectionTitle style={{ marginTop: "0" }}>
                <span>Capture Photo</span>
              </BookingsSectionTitle>
            </StyledGridCol>
          </StyledGridRow>
          <StyledGridRow gutter={16} style={{ height: "25rem" }}>
            <StyledGridCol span={24}>
              <>
                <Camera
                  ref={camera}
                  numberOfCamerasCallback={setNumberOfCameras}
                  facingMode="environment"
                  videoSourceDeviceId={activeDeviceId}
                  errorMessages={{
                    noCameraAccessible:
                      "No camera device accessible. Please connect your camera or try a different browser.",
                    permissionDenied:
                      "Permission denied. Please refresh and give camera permission.",
                    switchCamera:
                      "It is not possible to switch camera to different one because there is only one video device accessible.",
                    canvas: "Canvas is not supported.",
                  }}
                  videoReadyCallback={() => {}}
                />
              </>
            </StyledGridCol>
          </StyledGridRow>
          <StyledGridRow gutter={16} style={{ marginTop: "0.5rem" }}>
            <StyledGridCol span={12}>
              <Button type="default" color="default" onClick={takePhoto}>
                Take Photo
              </Button>
              {/* <Button
                type="default"
                color="default"
                hidden={numberOfCameras <= 1}
                onClick={() => {
                  camera.current.switchCamera();
                }}
              >
                Switch Camera
              </Button> */}
            </StyledGridCol>
            <StyledGridCol span={12}>
              <FormItem>
                <Select
                  placeholder="Switch Camera"
                  showSearch={false}
                  options={devices?.map((d) => {
                    return {
                      value: d?.deviceId,
                      label: d?.label,
                    };
                  })}
                  onChange={(event) => {
                    setActiveDeviceId(event);
                  }}
                />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
        </Modal>
      )}
    </>
  );
};

export default InmateHeader;
